import type { TheorySection } from "../../convex/lib/unclear";

/** Разделы страницы темы — как их называет сама страница. */
export const SECTION_LABEL: Record<TheorySection, string> = {
  why: "Зачем это нужно",
  rule: "Правило",
  example: "Разобранный пример",
  mistake: "Где теряют баллы",
};
